var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("記事編集")]),_c('v-card-text',[_c('NewArticle',{attrs:{"articleId":_vm.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }